import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
  Checkbox,
  Switch,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Add, Clear, DeleteOutline, EditOutlined } from "@mui/icons-material";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "moment";

import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import { DesktopDatePicker } from "@mui/lab";
import { DateTimePicker } from "@mui/x-date-pickers";
import { toast } from "react-toastify";
import NormalTable from "../../../Component/NormalTable";

const OrganizationModal = ({ mode, handleCloseClick, editData, getById }) => {
  const [loading, setLoading] = useState(false);
  const [menuSelect, setMenusSelect] = useState([]);
  const [menusMaster, setMenusMaster] = useState([]);
  const [licenceUserType, setLicenceUserType] = useState([]);
  const [licenceList, setLicenceList] = useState([]);
  const [licence, setLicence] = useState({
    licenceType: {
      id:null,
      userTypeName:""
    },
    licenceCount: "",
  });
  const [alreadySelMenu, setAlreadySelMenu] = useState([]);
  const [editLicence, setEditLicence] = useState({
    id: null,
    mode: false,
  });

  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    const menusLink = masterAPI["menus"].getMasterMenusOrg;
    axiosPrivate
      .get(`${menusLink}`)
      .then((res) => {
        setMenusMaster(res.data.result);
        console.log("menus", res.data.result);
      })
      .catch((e) => {
        setMenusMaster([]);
        console.log(e, "error");
      });

    const getLicenceType = masterAPI["licence"].licenceUserType;
    axiosPrivate
      .get(`${getLicenceType}`)
      .then((res) => {
        const filterUnDeleted=res.data.result.filter((undel,i)=>undel.isActive)
        setLicenceUserType(filterUnDeleted);
      })
      .catch((e) => {
        console.log(e);
        setLicenceUserType([]);
      });
    if (mode === "Edit" && editData) {
      // setMenusSelect(editData.orgMenusList || []);
      setAlreadySelMenu(editData.orgMenusList || []);
      setLicenceList(editData.licenceMasterList || []);
    }
    setLoading(false);
  };

  // const getByOrgId=()=>{
  //   const getMenuLink=masterAPI["orgMenus"].getByOrgId
  //   axiosPrivate.get(`${getMenuLink}/${editData.id}`).then(res=>{
  //     console.log(res)
  //     setAlreadySelMenu(res.data.result)
  //   }).catch(e=>{
  //     console.log(e)
  //   })
  //     }
  const initialValue = {
    organizationName: mode === "Edit" ? editData.organizationName : "",
    code: mode === "Edit" ? editData.code : "",
    orgMenusList: mode === "Edit" ? editData.orgMenusList : [],
    isMainSystem: mode === "Edit" ? editData.isMainSystem : false,
    // licenceMasterList:mode === "Edit" ? editData.licenceMasterList:[]
  };

  const onSubmit = async (value) => {
    // const orgMenusList = menuSelect.map((p) => ({
    //   ...(p.id
    //     ? { id: p.id, menuId: p.menuId, sequenceNumbers: p.sequenceNumbers }
    //     : {
    //         id: "00000000-0000-0000-0000-000000000000",
    //         menuId: p.menuId,
    //         sequenceNumbers: p.sequenceNumbers,
    //       }),
    // }));
    const payload = {
      ...value,
      orgMenusList: menuSelect,
      licenceMasterList: licenceList,
    };
    console.log("payload", payload);
    setLoading(true);
    const createLink = masterAPI["organization"].create;
    const updateLink = masterAPI["organization"].update;
    if (mode === "Create") {
      await axiosPrivate
        .post(`${createLink}`, payload)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "create organization");
        });
    } else {
      const updateAC = {
        id: editData.id,
        ...payload,
      };
      console.log("UpdatePayload", updateAC);
      await axiosPrivate
        .put(`${updateLink}`, updateAC)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "update organization");
        });
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };
  const menusColumns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: ({ cell }) => {
        const id = cell.row.original.id;

        const isChecked =
          menuSelect.some((menu) => menu.menuId === id) ||
          alreadySelMenu.some((menu) => menu.menuId === id);
        return (
          <Checkbox
            checked={isChecked}
            disabled={alreadySelMenu.some((menu) => menu.menuId === id)}
            onChange={(e) =>
              handleCheckMenus(e.target.checked, cell.row.original)
            }
            sx={{
              "&.Mui-disabled": {
                color: "#1976d2",
              },
            }}
          />
        );
      },
    },
    {
      Header: "Menus",
      accessor: "name",
    },
    {
      Header: "Action",
      enableHiding: mode === "Create" ? true : false,
      accessor: "isDeleted",
      // isVisible:false,
      Cell: ({ cell }) => {
        return (
          <IconButton
            disabled={
              !alreadySelMenu.some(
                (menu) => menu.menuId === cell.row.original.id
              )
            }
            onClick={() => {
              confirmDeleteMenu(
                alreadySelMenu.filter(
                  (fil) => fil.menuId === cell.row.original.id
                )[0].id
              );
            }}
          >
            <DeleteOutline
              sx={{
                fontSize: color.masterEditDelButton,
                color: !alreadySelMenu.some(
                  (menu) => menu.menuId === cell.row.original.id
                )
                  ? "default"
                  : color.masterEditDelButtonColor,
              }}
            />
          </IconButton>
        );
      },
      // disableFilters: true,
    },
  ];
  // const handleCheckMenus = (menus) => {
  //   setMenusSelect((prev) => {
  //     const exists = prev.find((p) => p.menuId === menus.id);
  //     if (exists) {
  //       if (mode === "Edit") {
  //         const menuObjectFromEditData = editData.orgMenusList.find(
  //           (r) => r.menuId === menus.id
  //         );

  //         confirmDeleteMenu(menuObjectFromEditData.id);

  //       }
  //       return prev.filter((p) => p.menuId !== menus.id);
  //     }

  //     return [
  //       ...prev,
  //       {
  //         menuId: menus.id,
  //         sequenceNumbers: menus.sequenceNumbers,
  //       },
  //     ];
  //   });
  // };

  const handleCheckMenus = (checked, menus) => {
    console.log(checked);
    if (checked) {
      setMenusSelect([
        ...menuSelect,
        {
          id: "00000000-0000-0000-0000-000000000000",
          menuId: menus.id,
          sequenceNumbers: menus.sequenceNumbers,
        },
      ]);
    } else {
      console.log(menuSelect);
      const filterMenusSelect = menuSelect.filter(
        (fil) => fil.menuId !== menus.id
      );
      console.log(filterMenusSelect);
      setMenusSelect(filterMenusSelect);
    }
    // else {
    //   const menuObjectFromEditData = editData.orgMenusList.find(
    //     (r) => r.menuId === menus.id
    //   );

    //   confirmDeleteMenu(
    //     menuObjectFromEditData !== undefined ? menuObjectFromEditData.id : menus.id,
    //     menuObjectFromEditData !== undefined ? "edit" : "create"
    //   );
    // }
  };
  const confirmDeleteMenu = (id) => {
    toast(
      <Grid>
        <Typography
          sx={{ fontSize: "15px", fontWeight: 600, color: "#797979" }}
        >
          Are you sure you want to remove this menus for this organization?
        </Typography>
        <Grid item container spacing={2}>
          <Grid item>
            <Button
              onClick={() => {
                handleDeleteMenus(id);
                toast.dismiss();
              }}
              sx={{ color: "grey", borderColor: "green" }}
              size="small"
              variant="outlined"
            >
              Yes
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => toast.dismiss()}
              sx={{ color: "grey", borderColor: "red" }}
              size="small"
              variant="outlined"
            >
              No
            </Button>
          </Grid>
        </Grid>
      </Grid>,
      {
        closeButton: false,
        autoClose: false,
      }
    );
  };
  const handleDeleteMenus = async (menuId) => {
    const menuDelete = masterAPI["orgMenus"].delete;
    await axiosPrivate
      .delete(`${menuDelete}/${menuId}`)
      .then((res) => {
        console.log(res);
        var filterMenu = alreadySelMenu.filter((fil) => fil.id !== menuId);
        setAlreadySelMenu(filterMenu);
        // getById();
        // toast.success("Deleted Successfully");
      })
      .catch((e) => {
        // toast.error("Not Removed");
        console.log(e, "error task delete");
      });
  };

  const confirmDeleteLicence = (event, id, code) => {
    toast(
      <Grid>
        <Typography
          sx={{ fontSize: "15px", fontWeight: 600, color: "#797979" }}
        >
          Are you sure you want to {event ? "active" : "deactive"} this licence
          for this organization?
        </Typography>
        <Grid item container spacing={2}>
          <Grid item>
            <Button
              onClick={() => {
                console.log(event);
                handleDeleteLicence(event, id, code);
                toast.dismiss();
              }}
              sx={{ color: "grey", borderColor: "green" }}
              size="small"
              variant="outlined"
            >
              Yes
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => toast.dismiss()}
              sx={{ color: "grey", borderColor: "red" }}
              size="small"
              variant="outlined"
            >
              No
            </Button>
          </Grid>
        </Grid>
      </Grid>,
      {
        closeButton: false,
        autoClose: false,
      }
    );
  };
  const handleDeleteLicence = (e, id, code) => {
    console.log(e);
    const enableLink = masterAPI["licence"].enable;
    const disableLink = masterAPI["licence"].disable;
    if (e) {
      console.log(e.target.checked);
      axiosPrivate
        .put(`${enableLink}/${id}/${code}`)
        .then((res) => {
          const updateData = licenceList.map((p) => ({
            ...(p.id === id ? { ...p, isActive: true } : p),
          }));
          console.log(updateData);
          setLicenceList(updateData);
        })
        .catch((e) => {
          // toast.error("Not Active");
        });
    } else {
      axiosPrivate
        .put(`${disableLink}/${id}/${code}`)
        .then((res) => {
          const updateData = licenceList.map((p) => ({
            ...(p.id === id ? { ...p, isActive: false } : p),
          }));
          console.log(updateData);
          setLicenceList(updateData);
        })
        .catch((e) => {
          // toast.error("Not Deactive");
        });
    }
  };

  const handleEdit = (value) => {
    setLicence({
      licenceType: {
        licenceUseTypeMasterId:value.original.id,
        id: value.original.licenceUserTypeId,
        userTypeName:value.original.userTypeName
      },
      licenceCount: value.original.licenceCount,
    });
    setEditLicence({
      id:value.id,
      mode:true
    })
  };

  const licenceColumn = [
    {
      Header: "Licence Name",
      accessor: "userTypeName",
    },
    {
      Header: "Count",
      accessor: "licenceCount",
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton>
              <EditOutlined
                onClick={() => {
                  handleEdit(cell.row);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
            <Switch
              disabled={cell.row.original.isActive === undefined}
              checked={cell.row.original.isActive}
              onChange={(e) => {
                confirmDeleteLicence(e.target.checked, cell.row.original.id, cell.row.original.code || cell.row.original.licenceCode || cell.row.original.userTypeCode || cell.row.original.userTypeName);
              }}
            />
          </Box>
        );
      },
    },
  ];

  const handleLicence = () => {
    if(editLicence.mode){
      const updateList=[...licenceList]
      console.log(      updateList[editLicence.id])
      updateList[editLicence.id]={
        ...updateList[editLicence.id],
        id: licence.licenceType.licenceUseTypeMasterId,
        licenceUserTypeId: licence.licenceType.id,
        userTypeName: licence.licenceType.userTypeName,
        licenceCount: licence.licenceCount,
      }
      setLicenceList(updateList)
    }else{
setLicenceList([
      ...licenceList,
      {
        id: "00000000-0000-0000-0000-000000000000",
        licenceUserTypeId: licence.licenceType.id,
        userTypeName: licence.licenceType.userTypeName,
        licenceCount: licence.licenceCount,
      },
    ]);
    }
    
    setLicence({  licenceType: {
      id:null,
      userTypeName:""
    }, licenceCount: 0 });
    setEditLicence({
      id:null,
      mode:false
    })
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit"
            ? editData.code + "-" + editData.organizationName
            : "New Organization"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Organization Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="code"
                  placeholder="Enter Organization Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Organization Name
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="organizationName"
                  placeholder="Enter Organization Name"
                  multiline
                  minRows={1}
                  maxRows={2}
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid
                container
                item
                xs={12}
                alignItems={"flex-end"}
                spacing={"1rem"}
              >
                <Grid item xs={12} md={4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Licence
                  </Typography>
                  <Field
                    as={Select}
                    // label={"Select"}
                    size={"small"}
                    readOnly={editLicence.mode}
                    value={licence.licenceType.id}
                    fullWidth
                    displayEmpty
                    MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                    renderValue={
                      licence.licenceType.id!== null
                        ? undefined
                        : () => (
                            <Typography
                              sx={{
                                color: color.placeholderColor,
                                fontSize: "13px",
                              }}
                            >
                              Select
                            </Typography>
                          )
                    }
                    // onChange={(e)=>{console.log(e)}}
                  >
                    {licenceUserType.map((id, i) => (
                      <MenuItem
                        value={id.id}
                        onClick={() => {
                          console.log(id)
                          setLicence({ ...licence, licenceType: id });
                        }}
                      >
                        {id.userTypeName}
                      </MenuItem>
                    ))}
                  </Field>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Count
                  </Typography>
                  <Field
                    as={TextField}
                    size={"small"}
                    type="number"
                    value={licence.licenceCount}
                    placeholder="Enter Count"
                    onChange={(e) => {
                      setLicence({ ...licence, licenceCount: e.target.value });
                    }}
                    fullWidth
                    sx={{
                      ".MuiInputBase-input": {
                        // letterSpacing: "0.2rem",

                        "&::placeholder": {
                          // color: "green",
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <IconButton
                    sx={{ background: "#2362B4" }}
                    onClick={() => {
                      handleLicence();
                    }}
                  >
                    <Add sx={{ color: "white" }} />
                  </IconButton>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: licenceList.length === 0 ? "none" : "default" }}
              >
                <NormalTable
                  data={licenceList}
                  columns={licenceColumn}
                  filt={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Main System
                </Typography>
                <Switch
                  checked={values.isMainSystem}
                  onChange={(e) => {
                    setFieldValue("isMainSystem", e.target.checked);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <NormalTable
                  data={menusMaster}
                  columns={menusColumns}
                  filt={true}
                />
              </Grid>{" "}
              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default OrganizationModal;
